<template>
    <div class="flex pt-1">
        <div class="cursor-pointer relative" @click="openMenu">
            <img class="pr-2" :src="getImage(gridType)" alt="">
            <i style="top:2px; right: -6px;" class="fas fa-caret-down absolute"></i>
        </div>

        <div class="relative" v-if="menuOpen" ref="dropdownMenuRef">
            <div class="absolute z-10" style="left: -80px; top: -8px;">
                <div class="bg-white border-gray-600 border shadow-md">
                    <ul class="list-none p-0">
                        <li class="cursor-pointer p-2">
                            <div class="text-center" @click="changeActive(null)">OFF</div>
                        </li>
                        <li class="cursor-pointer p-2 pt-0" v-for="gridType in gridTypes" :key="gridType">
                            <div class="text-center">
                                <img @click="changeActive(gridType)" :src="getImage(gridType)" alt="">
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onUnmounted } from 'vue';

const props = defineProps({
    initialType: String
});

const emit = defineEmits(['changed']);

const defaultTypes = ['2x1', '1x2', '1x3', '3x1', '2x2'];

const gridTypes = ref(defaultTypes);
const gridType = ref(props.initialType || defaultTypes[0]);
const menuOpen = ref(false);

const dropdownMenuRef = ref(null);

const changeActive = (newType) => {
    gridType.value = newType;
    closeMenu();
    emit('changed', gridType.value);
};

const getImage = (pImgType) => {
    if (!pImgType) return;
    return `/img/grid-charts/${pImgType}.png`;
};

const handleMouse = (eventName) => {
    if (dropdownMenuRef.value && !dropdownMenuRef.value.contains(eventName.target)) {
        closeMenu();
    }
};

const watchForMouseClick = () => {
    document.addEventListener('mousedown', handleMouse);
};

const openMenu = () => {
    menuOpen.value = true;
    watchForMouseClick();
};

const closeMenu = () => {
    menuOpen.value = false;
    document.removeEventListener('mousedown', handleMouse);
};

watch(() => props.initialType, (newType) => {
    gridType.value = newType;
});

onUnmounted(() => {
    document.removeEventListener('mousedown', handleMouse);
});
</script>
